const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');
import { axiosInstance as axios } from '../../utils/axios';

export const requestEquivalence = createAsyncThunk('request/equivalence', async (payload) => {
  try {
    let form = new FormData();
    console.log('requestEquivalence payload', payload.nif[0]);
    form.append('files', payload.nif[0]);
    const uploadFile = await axios
      .post('api/upload', form)
      .then((resp) => {
        const fileId = resp.data[0].id;

        console.log('fileId: ' + fileId);
        console.log('uploadFile response: ' + resp);
      })
      .catch((err) => {
        console.log('error to upload file: ' + err);
      });
    return uploadFile.data;
  } catch (error) {}
});

const initialState = {
  isLoading: false,
};

const equivalenceSlice = createSlice({
  name: 'equivalence',
  initialState,
  extraReducers: {
    [requestEquivalence.pending]: (state) => {
      state.isLoading = true;
    },
    [requestEquivalence.fulfilled]: (state, action) => {
      state.isLoading = false;
    },
    [requestEquivalence.rejected]: (state) => {
      state.isLoading = false;
    },
  },
});

export const equivalenceReducer = equivalenceSlice.reducer;

export const isSubmit = (state) => state.equivalence.isLoading;
